<div class="wrapper">
	<div class="container">
		<div class="brd_bx">
			<div class="row">
				<div class="col-lg-12">
					<div class="card m-b-30">
						<div class="card-body">
							<form action="" method="post" id="kasumbo_form" enctype="multipart/form-data">
								<div class="row">
									<div class="col-lg-12">
										<div class="card m-b-10">
											<div class="page-title-box row">
												<div class="col-md-6">
													<div class="btn-group ">
														<h4 class="page-title">Kasumbo Add</h4>
													</div>
												</div>
												<div class="col-md-6">
													<div class="btn-group pull-right">
														<div>
															<button (click)="submit_form()"
																class="btn btn-success waves-effect waves-light m-r-5">Save
																Kasumbo</button>
															<a href="javascript:void(0);" routerLink="/kasumbo-list"
																type="button"
																class="btn btn-secondary waves-effect m-l-5">Cancel</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<input class="form-control" type="hidden" name="title" value="" id="title">
								<input class="form-control" value="" type="hidden" name="gred_line_below" value=""
									id="gred_line_below">
								<input class="form-control" value="" type="hidden" name="content1" value=""
									id="content1">
								<input class="form-control" type="hidden" name="display_order" value="1"
									id="display_order">

								<div class="form-group row">
									<div class="col-md-6 row">
										<label for="image1" class="col-sm-4 col-form-label">Heading image 1: </label>
										<div class="col-sm-8">
											<input type="hidden" name="ori_image_1" value="{{NewsData?.image}}">
											<input id="image1" type="file" class="form-control" name="image_1" #file
												type="file" (change)="imageValidation($event,1)" accept='image/*'>
											<img [src]="imageURL" *ngIf="imageURL"
												style="max-width:300px;margin-top:15px">
										</div>
									</div>
								</div>


								<div class="form-group row">
									<div class="col-md-6 row">
										<label class="col-sm-4 col-form-label">News Date: </label>
										<div class="col-sm-8">
											<input class="form-control" data-validation="required" type="text"
												name="news_date" value="{{news_date}}" id="news_date">
										</div>
									</div>
								</div>

								<input type="hidden" name="newsID" value="{{NewsData?._id}}">
								<div class="form-group">
									<div>
										<button (click)="submit_form()"
											class="btn btn-success waves-effect waves-light m-r-5">Save Kasumbo</button>
										<a href="javascript:void(0);" routerLink="/kasumbo-list" type="button"
											class="btn btn-secondary waves-effect m-l-5">Cancel</a>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>